import { render, staticRenderFns } from "./Product-Certificate.vue?vue&type=template&id=0342ff06&scoped=true"
import script from "./Product-Certificate.vue?vue&type=script&lang=js"
export * from "./Product-Certificate.vue?vue&type=script&lang=js"
import style0 from "./Product-Certificate.vue?vue&type=style&index=0&id=0342ff06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0342ff06",
  null
  
)

export default component.exports